import { render, staticRenderFns } from "./BookingConfirmationTimeout.vue?vue&type=template&id=53116119&scoped=true"
import script from "./BookingConfirmationTimeout.vue?vue&type=script&lang=js"
export * from "./BookingConfirmationTimeout.vue?vue&type=script&lang=js"
import style0 from "./BookingConfirmationTimeout.vue?vue&type=style&index=0&id=53116119&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53116119",
  null
  
)

export default component.exports